import { render, staticRenderFns } from "./BuscaVazia.vue?vue&type=template&id=292a8f76&scoped=true"
import script from "./BuscaVazia.vue?vue&type=script&lang=js"
export * from "./BuscaVazia.vue?vue&type=script&lang=js"
import style0 from "./BuscaVazia.vue?vue&type=style&index=0&id=292a8f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292a8f76",
  null
  
)

export default component.exports